function Footer() {
    return (
        <footer className="border-top footer text-muted py-2">
            <div className="container">&copy; 2021 - J-Fit - WebApp by Mohamed Nathoo</div>
        </footer>
    );
}

export default Footer;
